import React, { Component } from 'react'
import { connect } from 'react-redux';

import { GetDiningLocations, DeleteDiningLocation } from '../../actions/diningLocationActions'

import DeleteDiningLocationModal from './DeleteDiningLocationModal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, IconButton, Modal } from '@material-ui/core';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

class DiningLocations extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            selected: undefined
        };
    };

    
    handleDelete=(e,location)=>{

        this.setState({
            selected:location,
            open:true

        })
    }

    handleDeleteLocation =()=>{
        if(this.state.selected){
            this.props.DeleteDiningLocation(this.state.selected._id);

        }

        this.setState({
            selected:undefined,
            open:false
        })
    }

    handleEditDiningLocation=(e, loc)=>{
        if(loc && !loc.disableActions){
            this.props.onSelectLocation(loc)
        }
    }


    render() {
        return (
            <>
                <Grid item container xs={12}>

                    <Grid item container xs={12} className="titleEngageStyleHeadersBook" style={{ padding:'0px 10px' }} >
                        <Grid item container xs={10} sm={10} md={10} lg={11} alingItems='center' justifyContent='center'>
                            <Grid item xs={3} sm={3} md={3} lg={2} style={{textAlign:'center'}}>Icon</Grid>
                            <Grid item xs={9} sm={9} md={9} lg={10}>Name</Grid>
                        </Grid>
                      
                        <Grid item md={2} lg={1}></Grid>
                    </Grid>
                  
                    {
                        this.props.locationData && this.props.locationData.map(location=>{

                            return(
                                <Grid item container xs={12} className="categoryRow" key={`dining_location_row_${location._id}`} 
                                    alignItems='center' style={{cursor:(!location.disableActions)?'pointer':'auto'}} 
                                >
                                    <Grid item container xs={10} sm={10} md={10} lg={11} alignItems='center' onClick={(e)=>this.handleEditDiningLocation(e,location)}>
                                       
                                        <Grid item container xs={3} sm={3} md={3} lg={2} justifyContent='center'>
                                            {
                                                <span style={{fontFamily:'Gotham-Book', fontSize:'60px'}}>{location.name && location.name.length>0? location.name.charAt(0).toUpperCase():''}</span>
                                            }
                                          
                                        </Grid>

                                        <Grid item xs={9} sm={9} md={9} lg={10}>{location.name}</Grid>

                                    </Grid>
                                   
                                    <Grid item container xs={2} sm={2} md={2} lg={1}>
                                        {
                                            (!location.disableActions) &&
                                            <IconButton onClick={(e)=>this.handleDelete(e,location)}>
                                                <FontAwesomeIcon
                                                    icon={faTrashAlt}
                                                    color='#c43740'
                                                    size='2x'
                                                />
                                            </IconButton>
                                        }
                
                                    </Grid>

                                </Grid>
                            )
                        })
                    }

                </Grid>
                
                <Modal
                    open={this.state.open}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ borderRadius: '16px' }}
                    onClose={() => this.setState({open:false, selected:undefined})}
                >
                    <DeleteDiningLocationModal
                        location={this.state.selected}
                        close={() =>this.setState({ open: false, selected:undefined })}
                        onDelete={this.handleDeleteLocation}
                    />

                </Modal>
            </>
        )
    }
}


function mapStateToProps(state) {
    const locationData = (state.diningLocationReducer?.diningLocationData) ? state.diningLocationReducer.diningLocationData : [];

    return {
        locationData
    }
};

export default connect(mapStateToProps, {GetDiningLocations, DeleteDiningLocation})(DiningLocations);
